import { defineComponent as _defineComponent } from 'vue'
import { computed, StyleValue } from 'vue';
import { ArtemisTimelineItem, isArtemisTimeline, isServiceSuccess, ServiceResult } from '@/data.types';
import { formatDataPoints } from '@/data.functions';

interface Props {
  data: ServiceResult
}

export default /*#__PURE__*/_defineComponent({
  __name: 'stage-display',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: ServiceResult
};



function getTextColorFromNamedBackground(bgColor: string) {
  // Use a temporary element to resolve the named color
  const el = document.createElement('div');
  el.style.color = bgColor;
  document.body.appendChild(el);
  const rgb = window.getComputedStyle(el).color;
  document.body.removeChild(el);

  // Convert to an array of floats in 0–255
  const match = rgb.match(/(\d+\.?\d*)/g);
  const [r, g, b] = match ? match.map(Number) : [0, 0, 0];
  const normalize = (c: number) => ((c / 255) <= 0.03928)
    ? c / 255 / 12.92
    : Math.pow((c / 255 + 0.055) / 1.055, 2.4);

  const lR = normalize(r);
  const lG = normalize(g);
  const lB = normalize(b);

  const lum = 0.2126 * lR + 0.7152 * lG + 0.0722 * lB;

  return lum > 0.5 ? '#000000' : '#ffffff';
}


const timeline = computed(() => isServiceSuccess(props.data) && isArtemisTimeline(props.data.data) ? props.data.data : null)

const phase = computed(() => {
  let res: ArtemisTimelineItem = { start: 0, end: 0, title: "n/a" };
  if (timeline.value) {
    const item = timeline.value.data.standard.phase.at(0);
    if (item) res = item
  }
  return res
})
const attitude = computed(() => {
  let res: ArtemisTimelineItem = { start: 0, end: 0, title: "n/a" };
  if (timeline.value) {
    const item = timeline.value.data.standard.attitude.at(0);
    if (item) res = item
  }
  return res
})

const simple = computed(() => (timeline.value?.data.simple || []).map((data) => ({
  name: data.name,
  title: `The ${data.name} (${data?.description}) state is ${data.timeline.at(0)?.active ? 'active' : 'standby'}`,
  style: {
    background: data.timeline.at(0)?.active ? data.color : '',
    color: data.timeline.at(0)?.active ? getTextColorFromNamedBackground(data.color) : data.color,
    padding: "1px 6px"
  }
})
))


return { __sfc: true,props, getTextColorFromNamedBackground, timeline, phase, attitude, simple }
}

})